// File: frontend/src/mocks/reinsurance/capitalData.js

export const mockCapitalPosition = {
  success: true,
  data: {
    investor_id: "j3k4l5m6-n7o8-p9q0-r1s2-t3u4v5w6x7y8",
    total_capital: 100000000,
    total_allocated: 75000000,
    total_available: 25000000,
    allocation_percentage: 75,
    capital_records: [
      {
        capital_id: "a1b2c3d4-e5f6-g7h8-i9j0-k1l2m3n4o5p6",
        amount: 40000000,
        currency: "USD",
        inception_date: "2024-11-15T00:00:00Z",
        maturity_date: "2025-11-14T23:59:59Z",
        total_allocated: 30000000,
        available: 10000000,
        allocation_percentage: 75
      },
      {
        capital_id: "q7r8s9t0-u1v2-w3x4-y5z6-a7b8c9d0e1f2",
        amount: 30000000,
        currency: "USD",
        inception_date: "2025-01-10T00:00:00Z",
        maturity_date: "2026-01-09T23:59:59Z",
        total_allocated: 22500000,
        available: 7500000,
        allocation_percentage: 75
      },
      {
        capital_id: "g3h4i5j6-k7l8-m9n0-o1p2-q3r4s5t6u7v8",
        amount: 30000000,
        currency: "USD",
        inception_date: "2025-03-01T00:00:00Z",
        maturity_date: "2026-02-28T23:59:59Z",
        total_allocated: 22500000,
        available: 7500000,
        allocation_percentage: 75
      }
    ],
    contract_allocations: [
      {
        contract_id: "c8f9d2e1-6b7a-4c5d-8e3f-2a1b0c9d8e7f",
        total_allocated: 12000000,
        allocations: [
          {
            allocation_id: "w9x0y1z2-a3b4-c5d6-e7f8-g9h0i1j2k3l4",
            capital_id: "a1b2c3d4-e5f6-g7h8-i9j0-k1l2m3n4o5p6",
            amount: 8000000,
            percentage: 53.33,
            expected_return: 12.5
          },
          {
            allocation_id: "m5n6o7p8-q9r0-s1t2-u3v4-w5x6y7z8a9b0",
            capital_id: "q7r8s9t0-u1v2-w3x4-y5z6-a7b8c9d0e1f2",
            amount: 4000000,
            percentage: 26.67,
            expected_return: 11.8
          }
        ],
        contract: {
          contract_id: "c8f9d2e1-6b7a-4c5d-8e3f-2a1b0c9d8e7f",
          contract_number: "RIL-240315-789",
          rnr: "RNR5A3F2",
          contract_type: "property",
          cedent_name: "Global Insurance Co.",
          effective_date: "2025-01-01T00:00:00Z",
          expiration_date: "2025-12-31T23:59:59Z",
          limit: 15000000,
          current_status: "active"
        }
      },
      {
        contract_id: "a7b6c5d4-e3f2-1g0h-9i8j-7k6l5m4n3o2p",
        total_allocated: 8000000,
        allocations: [
          {
            allocation_id: "c1d2e3f4-g5h6-i7j8-k9l0-m1n2o3p4q5r6",
            capital_id: "a1b2c3d4-e5f6-g7h8-i9j0-k1l2m3n4o5p6",
            amount: 5000000,
            percentage: 50,
            expected_return: 14.2
          },
          {
            allocation_id: "s7t8u9v0-w1x2-y3z4-a5b6-c7d8e9f0g1h2",
            capital_id: "g3h4i5j6-k7l8-m9n0-o1p2-q3r4s5t6u7v8",
            amount: 3000000,
            percentage: 30,
            expected_return: 13.5
          }
        ],
        contract: {
          contract_id: "a7b6c5d4-e3f2-1g0h-9i8j-7k6l5m4n3o2p",
          contract_number: "RIL-240422-456",
          rnr: "RNR7B2D9",
          contract_type: "specialty",
          cedent_name: "Pacific Mutual",
          effective_date: "2025-02-15T00:00:00Z",
          expiration_date: "2026-02-14T23:59:59Z",
          limit: 10000000,
          current_status: "active"
        }
      },
      {
        contract_id: "1a2b3c4d-5e6f-7g8h-9i0j-1k2l3m4n5o6p",
        total_allocated: 16000000,
        allocations: [
          {
            allocation_id: "i3j4k5l6-m7n8-o9p0-q1r2-s3t4u5v6w7x8",
            capital_id: "a1b2c3d4-e5f6-g7h8-i9j0-k1l2m3n4o5p6",
            amount: 6000000,
            percentage: 30,
            expected_return: 15.3
          },
          {
            allocation_id: "y9z0a1b2-c3d4-e5f6-g7h8-i9j0k1l2m3n4",
            capital_id: "q7r8s9t0-u1v2-w3x4-y5z6-a7b8c9d0e1f2",
            amount: 5000000,
            percentage: 25,
            expected_return: 14.8
          },
          {
            allocation_id: "o5p6q7r8-s9t0-u1v2-w3x4-y5z6a7b8c9d0",
            capital_id: "g3h4i5j6-k7l8-m9n0-o1p2-q3r4s5t6u7v8",
            amount: 5000000,
            percentage: 25,
            expected_return: 14.5
          }
        ],
        contract: {
          contract_id: "1a2b3c4d-5e6f-7g8h-9i0j-1k2l3m4n5o6p",
          contract_number: "RIL-240501-123",
          rnr: "RNR3K9P7",
          contract_type: "parametric",
          cedent_name: "Atlantic Re",
          effective_date: "2025-03-01T00:00:00Z",
          expiration_date: "2026-02-28T23:59:59Z",
          limit: 20000000,
          current_status: "bound"
        }
      }
    ],
    claims_summary: {
      total_claims: 5,
      total_incurred: 12500000,
      total_paid: 3750000,
      total_reserved: 8750000
    }
  }
};

export const mockAllocateCapitalResponse = {
  success: true,
  message: "Capital allocated successfully",
  data: {
    allocation_id: "r5s6t7u8-v9w0-x1y2-z3a4-b5c6d7e8f9g0",
    capital_id: "a1b2c3d4-e5f6-g7h8-i9j0-k1l2m3n4o5p6",
    contract_id: "q7r8s9t0-u1v2-w3x4-y5z6-a7b8c9d0e1f2",
    amount: 3000000,
    available_capital: 7000000
  }
};

export const mockUpdateAllocationResponse = {
  success: true,
  message: "Allocation updated successfully",
  data: {
    allocation_id: "w9x0y1z2-a3b4-c5d6-e7f8-g9h0i1j2k3l4",
    capital_id: "a1b2c3d4-e5f6-g7h8-i9j0-k1l2m3n4o5p6",
    contract_id: "c8f9d2e1-6b7a-4c5d-8e3f-2a1b0c9d8e7f",
    amount: 10000000,
    available_capital: 8000000
  }
};

export const mockOptimizeAllocationResponse = {
  success: true,
  message: "Optimization completed successfully",
  data: {
    capital_id: "a1b2c3d4-e5f6-g7h8-i9j0-k1l2m3n4o5p6",
    available_capital: 10000000,
    allocated_capital: 10000000,
    remaining_capital: 0,
    expected_return: 13.8,
    strategy: "optimal",
    allocations: [
      {
        contract_id: "1a2b3c4d-5e6f-7g8h-9i0j-1k2l3m4n5o6p",
        contract_number: "RIL-240501-123",
        rnr: "RNR3K9P7",
        amount: 4000000,
        percentage: 20,
        expected_return: 15.3
      },
      {
        contract_id: "a7b6c5d4-e3f2-1g0h-9i8j-7k6l5m4n3o2p",
        contract_number: "RIL-240422-456",
        rnr: "RNR7B2D9",
        amount: 3000000,
        percentage: 30,
        expected_return: 14.2
      },
      {
        contract_id: "q7r8s9t0-u1v2-w3x4-y5z6-a7b8c9d0e1f2",
        contract_number: "RIL-250115-234",
        rnr: "RNR8F4G2",
        amount: 3000000,
        percentage: 25,
        expected_return: 11.5
      }
    ]
  }
};